import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Fire-and-forget beacon for knowledge-base reads.
 *
 * Records a coarse trace (salted IP hash + which entries were served) so that
 * traversal-style harvesting of the library surfaces as an admin risk alert.
 * Never blocks rendering and never surfaces errors to the user.
 */
export const useWikiAccessBeacon = (
  table: 'therapy_wiki' | 'nutrient_wiki',
  rowIds: string[] | undefined,
) => {
  const sentRef = useRef<string | null>(null);

  useEffect(() => {
    if (!rowIds || rowIds.length === 0) return;
    const key = `${table}:${rowIds.length}:${rowIds[0]}:${rowIds[rowIds.length - 1]}`;
    if (sentRef.current === key) return;
    sentRef.current = key;

    void supabase.functions
      .invoke('wiki-access-log', {
        body: {
          table,
          row_ids: rowIds.slice(0, 500),
          path: typeof window !== 'undefined' ? window.location.pathname : null,
        },
      })
      .catch(() => {
        /* silent */
      });
  }, [table, rowIds]);
};
